export const featuredComics = [
  {
    id: 'sword-snow',
    title: '剑雪归途',
    author: '李寒月',
    categorySlug: 'wuxia',
    category: '古风武侠',
    cover: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20ink%20wash%20painting%20style%20manhwa%20cover%2C%20a%20swordsman%20in%20flowing%20white%20robes%20standing%20on%20a%20snowy%20mountain%20peak%2C%20holding%20a%20long%20sword%2C%20traditional%20ink%20brush%20texture%2C%20elegant%20composition%2C%20soft%20atmospheric%20perspective%2C%20minimalist%20background%20with%20misty%20mountains%2C%20warm%20sepia%20undertones%2C%20vertical%20scroll%20format&width=800&height=1000&seq=comic-cover-01&orientation=portrait',
    rating: 9.7,
    views: '1280万',
    latestChapter: '第87话',
    updateDate: '2026-07-03',
    isHot: true,
    isNew: true,
    description: '江湖飘零二十载，一剑光寒十九州。昔日少年归来，雪满长安道。',
    chapters: 87,
    status: '连载中',
  },
  {
    id: 'phantom-cat',
    title: '幻夜猫妖录',
    author: '墨染青衫',
    categorySlug: 'fantasy',
    category: '玄幻奇幻',
    cover: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20fantasy%20manhwa%20cover%20art%2C%20a%20mysterious%20cat%20spirit%20with%20flowing%20ethereal%20fur%20in%20a%20moonlit%20bamboo%20forest%2C%20traditional%20ink%20painting%20style%2C%20soft%20blue%20and%20silver%20tones%2C%20dreamy%20atmosphere%2C%20elegant%20vertical%20composition%2C%20minimalist%20background%20with%20floating%20spirit%20lights&width=800&height=1000&seq=comic-cover-02&orientation=portrait',
    rating: 9.5,
    views: '960万',
    latestChapter: '第63话',
    updateDate: '2026-07-02',
    isHot: true,
    isNew: false,
    description: '一只千年猫妖与落魄书生的奇异羁绊，揭开沉睡已久的幻夜之谜。',
    chapters: 63,
    status: '连载中',
  },
  {
    id: 'peach-blossom',
    title: '桃花庵下',
    author: '苏小暖',
    categorySlug: 'romance',
    category: '古风言情',
    cover: 'https://readdy.ai/api/search-image?query=Romantic%20ancient%20Chinese%20style%20manhwa%20cover%2C%20a%20beautiful%20woman%20in%20flowing%20pink%20hanfu%20under%20blooming%20peach%20blossom%20trees%2C%20soft%20watercolor%20painting%20style%2C%20warm%20pink%20and%20cream%20tones%2C%20gentle%20spring%20atmosphere%2C%20elegant%20vertical%20format%2C%20minimalist%20composition%20with%20falling%20petals&width=800&height=1000&seq=comic-cover-03&orientation=portrait',
    rating: 9.6,
    views: '1520万',
    latestChapter: '第102话',
    updateDate: '2026-07-03',
    isHot: true,
    isNew: true,
    description: '桃花坞里桃花庵，桃花庵下桃花仙。一段跨越三生三世的绝美爱恋。',
    chapters: 102,
    status: '连载中',
  },
  {
    id: 'dragon-seal',
    title: '龙印传说',
    author: '画龙客',
    categorySlug: 'wuxia',
    category: '古风武侠',
    cover: 'https://readdy.ai/api/search-image?query=Epic%20ancient%20Chinese%20dragon%20themed%20manhwa%20cover%2C%20a%20warrior%20with%20dragon%20tattoo%20on%20his%20back%20facing%20a%20giant%20golden%20dragon%20in%20stormy%20clouds%2C%20ink%20wash%20and%20gold%20foil%20style%2C%20dramatic%20lighting%2C%20vertical%20composition%2C%20minimalist%20dark%20background%20with%20lightning%20flashes&width=800&height=1000&seq=comic-cover-04&orientation=portrait',
    rating: 9.4,
    views: '890万',
    latestChapter: '第75话',
    updateDate: '2026-07-01',
    isHot: true,
    isNew: false,
    description: '龙印现世，天下大乱。少年身负龙印，踏上逆天改命之路。',
    chapters: 75,
    status: '连载中',
  },
  {
    id: 'jade-pavilion',
    title: '玉楼春',
    author: '月上柳梢',
    categorySlug: 'romance',
    category: '古风言情',
    cover: 'https://readdy.ai/api/search-image?query=Elegant%20ancient%20Chinese%20palace%20romance%20manhwa%20cover%2C%20a%20noble%20lady%20in%20luxurious%20green%20silk%20hanfu%20in%20a%20moonlit%20jade%20pavilion%2C%20traditional%20gongbi%20painting%20style%2C%20delicate%20details%2C%20soft%20jade%20green%20and%20gold%20tones%2C%20refined%20vertical%20format%2C%20elegant%20minimalist%20background&width=800&height=1000&seq=comic-cover-05&orientation=portrait',
    rating: 9.3,
    views: '750万',
    latestChapter: '第58话',
    updateDate: '2026-07-02',
    isHot: false,
    isNew: true,
    description: '玉楼春色深，一入宫门误终身。她本是江南商贾之女，却因一道圣旨入了深宫。',
    chapters: 58,
    status: '连载中',
  },
  {
    id: 'shadow-blade',
    title: '影刃',
    author: '暗夜行者',
    categorySlug: 'wuxia',
    category: '古风武侠',
    cover: 'https://readdy.ai/api/search-image?query=Dark%20ancient%20Chinese%20assassin%20themed%20manhwa%20cover%2C%20a%20masked%20figure%20in%20black%20robes%20holding%20twin%20daggers%20in%20a%20rainy%20night%20alley%2C%20ink%20splash%20style%2C%20high%20contrast%20black%20and%20crimson%20tones%2C%20dramatic%20composition%2C%20vertical%20format%2C%20minimalist%20background%20with%20rain%20streaks&width=800&height=1000&seq=comic-cover-06&orientation=portrait',
    rating: 9.2,
    views: '680万',
    latestChapter: '第49话',
    updateDate: '2026-06-30',
    isHot: false,
    isNew: false,
    description: '夜幕之下，影刃无声。他是江湖最神秘的刺客，也是唯一不愿杀人的杀手。',
    chapters: 49,
    status: '连载中',
  },
  {
    id: 'star-luo-jianghu',
    title: '星落江湖',
    author: '北辰',
    categorySlug: 'fantasy',
    category: '玄幻奇幻',
    cover: 'https://readdy.ai/api/search-image?query=Stunning%20ancient%20Chinese%20fantasy%20manhwa%20cover%2C%20a%20young%20warrior%20reaching%20for%20falling%20stars%20in%20a%20vast%20cosmic%20landscape%2C%20ink%20wash%20and%20starry%20night%20fusion%20style%2C%20deep%20indigo%20and%20gold%20star%20tones%2C%20vertical%20format%2C%20breathtaking%20composition&width=800&height=1000&seq=comic-cover-07&orientation=portrait',
    rating: 9.8,
    views: '1620万',
    latestChapter: '第92话',
    updateDate: '2026-07-03',
    isHot: true,
    isNew: true,
    description: '星辰坠落于江湖，少年拾起一片星空。北辰以独特笔触勾勒浩瀚世界，每一帧都可入画。',
    chapters: 92,
    status: '连载中',
  },
  {
    id: 'palace-conspiracy',
    title: '凤唳九天',
    author: '水月无痕',
    categorySlug: 'palace',
    category: '宫斗权谋',
    cover: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20palace%20intrigue%20manhwa%20cover%2C%20a%20majestic%20empress%20in%20golden%20phoenix%20robes%20standing%20in%20a%20grand%20palace%20hall%2C%20traditional%20gongbi%20painting%20style%2C%20rich%20gold%20and%20crimson%20tones%2C%20dramatic%20lighting%2C%20vertical%20composition&width=800&height=1000&seq=comic-cover-08&orientation=portrait',
    rating: 9.5,
    views: '1080万',
    latestChapter: '第71话',
    updateDate: '2026-07-02',
    isHot: true,
    isNew: false,
    description: '一朝入宫门，步步皆惊心。她以柔弱之躯，在波谲云诡的后宫中杀出一条血路。',
    chapters: 71,
    status: '连载中',
  },
  {
    id: 'spring-laugh',
    title: '江湖笑传',
    author: '风清扬',
    categorySlug: 'comedy',
    category: '轻松搞笑',
    cover: 'https://readdy.ai/api/search-image?query=Humorous%20ancient%20Chinese%20style%20manhwa%20cover%2C%20a%20comical%20young%20martial%20artist%20making%20funny%20faces%20with%20exaggerated%20expressions%2C%20bright%20and%20cheerful%20ink%20painting%20style%2C%20warm%20yellow%20and%20orange%20tones%2C%20playful%20vertical%20composition&width=800&height=1000&seq=comic-cover-09&orientation=portrait',
    rating: 9.1,
    views: '720万',
    latestChapter: '第56话',
    updateDate: '2026-07-01',
    isHot: false,
    isNew: true,
    description: '一本正经地搞笑，不正经地行走江湖。笑到肚子疼的武侠喜剧！',
    chapters: 56,
    status: '连载中',
  },
  {
    id: 'ghost-tales',
    title: '幽冥客栈',
    author: '夜不语',
    categorySlug: 'horror',
    category: '悬疑惊悚',
    cover: 'https://readdy.ai/api/search-image?query=Dark%20horror%20ancient%20Chinese%20manhwa%20cover%2C%20an%20eerie%20abandoned%20inn%20in%20misty%20mountains%20at%20night%2C%20ghostly%20figure%20in%20the%20window%2C%20ink%20wash%20horror%20style%2C%20cold%20blue%20and%20grey%20tones%2C%20haunting%20vertical%20composition&width=800&height=1000&seq=comic-cover-10&orientation=portrait',
    rating: 9.3,
    views: '640万',
    latestChapter: '第44话',
    updateDate: '2026-06-30',
    isHot: false,
    isNew: false,
    description: '深山老林中的神秘客栈，每一位入住的客人都会做同一个噩梦……',
    chapters: 44,
    status: '连载中',
  },
  {
    id: 'ink-painter',
    title: '画骨师',
    author: '水月无痕',
    categorySlug: 'romance',
    category: '古风言情',
    cover: 'https://readdy.ai/api/search-image?query=Romantic%20ancient%20Chinese%20painter%20manhwa%20cover%2C%20a%20talented%20female%20painter%20holding%20brush%20in%20a%20studio%20filled%20with%20ink%20paintings%2C%20soft%20ink%20wash%20style%2C%20warm%20cream%20and%20grey%20tones%2C%20elegant%20vertical%20composition&width=800&height=1000&seq=comic-cover-11&orientation=portrait',
    rating: 9.2,
    views: '580万',
    latestChapter: '第38话',
    updateDate: '2026-06-29',
    isHot: false,
    isNew: false,
    description: '她能为天下万物画骨，却画不出自己的心。一段画中情缘，唯美催泪。',
    chapters: 38,
    status: '连载中',
  },
  {
    id: 'palace-secret',
    title: '深宫谍影',
    author: '慕容清',
    categorySlug: 'palace',
    category: '宫斗权谋',
    cover: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20palace%20spy%20manhwa%20cover%2C%20a%20maid%20secretly%20passing%20a%20message%20in%20a%20dark%20palace%20corridor%2C%20dramatic%20chiaroscuro%20lighting%2C%20ink%20wash%20style%20with%20crimson%20accents%2C%20suspenseful%20vertical%20composition&width=800&height=1000&seq=comic-cover-12&orientation=portrait',
    rating: 9.4,
    views: '860万',
    latestChapter: '第65话',
    updateDate: '2026-07-02',
    isHot: false,
    isNew: true,
    description: '她是宫女，也是谍者。在深宫高墙之内，每一步都走在刀尖之上。',
    chapters: 65,
    status: '连载中',
  },
  {
    id: 'taoist-chef',
    title: '仙厨小当家',
    author: '食为天',
    categorySlug: 'comedy',
    category: '轻松搞笑',
    cover: 'https://readdy.ai/api/search-image?query=Funny%20ancient%20Chinese%20cooking%20manhwa%20cover%2C%20a%20young%20chef%20holding%20a%20magical%20wok%20with%20glowing%20ingredients%20flying%20around%2C%20bright%20and%20colorful%20ink%20style%2C%20warm%20orange%20and%20green%20tones%2C%20playful%20vertical%20composition&width=800&height=1000&seq=comic-cover-13&orientation=portrait',
    rating: 9.0,
    views: '550万',
    latestChapter: '第42话',
    updateDate: '2026-06-28',
    isHot: false,
    isNew: false,
    description: '修仙太累？不如做饭！被贬下凡的仙厨，在人间开起了一家神奇小餐馆。',
    chapters: 42,
    status: '连载中',
  },
  {
    id: 'blood-moon',
    title: '血月录',
    author: '鬼手',
    categorySlug: 'horror',
    category: '悬疑惊悚',
    cover: 'https://readdy.ai/api/search-image?query=Creepy%20ancient%20Chinese%20supernatural%20manhwa%20cover%2C%20a%20blood%20red%20moon%20over%20an%20ancient%20village%2C%20shadowy%20figures%20lurking%2C%20dark%20ink%20wash%20horror%20style%2C%20deep%20red%20and%20black%20tones%2C%20terrifying%20vertical%20composition&width=800&height=1000&seq=comic-cover-14&orientation=portrait',
    rating: 9.1,
    views: '490万',
    latestChapter: '第33话',
    updateDate: '2026-06-27',
    isHot: false,
    isNew: false,
    description: '血月当空，阴兵借道。一个小镇的诡异事件，揭开百年诅咒的真相。',
    chapters: 33,
    status: '连载中',
  },
  {
    id: 'qilin-blessing',
    title: '麒麟赐福',
    author: '祥瑞君',
    categorySlug: 'fantasy',
    category: '玄幻奇幻',
    cover: 'https://readdy.ai/api/search-image?query=Majestic%20ancient%20Chinese%20mythical%20manhwa%20cover%2C%20a%20divine%20qilin%20creature%20descending%20from%20heaven%20with%20golden%20light%2C%20traditional%20ink%20and%20gold%20style%2C%20warm%20gold%20and%20cream%20tones%2C%20awe-inspiring%20vertical%20composition&width=800&height=1000&seq=comic-cover-15&orientation=portrait',
    rating: 9.6,
    views: '980万',
    latestChapter: '第80话',
    updateDate: '2026-07-03',
    isHot: true,
    isNew: false,
    description: '麒麟现世，天下太平。少年偶得麒麟之力，开启一段笑泪交织的修真之旅。',
    chapters: 80,
    status: '连载中',
  },
];

export const hotRankings = [
  { rank: 1, id: 'peach-blossom', title: '桃花庵下', author: '苏小暖', category: '古风言情', heat: '1520万', isRising: true },
  { rank: 2, id: 'star-luo-jianghu', title: '星落江湖', author: '北辰', category: '玄幻奇幻', heat: '1620万', isRising: true },
  { rank: 3, id: 'sword-snow', title: '剑雪归途', author: '李寒月', category: '古风武侠', heat: '1280万', isRising: true },
  { rank: 4, id: 'palace-conspiracy', title: '凤唳九天', author: '水月无痕', category: '宫斗权谋', heat: '1080万', isRising: true },
  { rank: 5, id: 'qilin-blessing', title: '麒麟赐福', author: '祥瑞君', category: '玄幻奇幻', heat: '980万', isRising: false },
  { rank: 6, id: 'phantom-cat', title: '幻夜猫妖录', author: '墨染青衫', category: '玄幻奇幻', heat: '960万', isRising: false },
  { rank: 7, id: 'dragon-seal', title: '龙印传说', author: '画龙客', category: '古风武侠', heat: '890万', isRising: true },
  { rank: 8, id: 'palace-secret', title: '深宫谍影', author: '慕容清', category: '宫斗权谋', heat: '860万', isRising: true },
];

export const categories = [
  { id: 'wuxia', slug: 'wuxia', name: '古风武侠', icon: 'ri-sword-line', count: 1280, description: '侠骨柔情，仗剑天涯' },
  { id: 'romance', slug: 'romance', name: '古风言情', icon: 'ri-heart-line', count: 1560, description: '才子佳人，情深缘浅' },
  { id: 'fantasy', slug: 'fantasy', name: '玄幻奇幻', icon: 'ri-magic-line', count: 980, description: '仙魔争锋，幻境奇缘' },
  { id: 'palace', slug: 'palace', name: '宫斗权谋', icon: 'ri-building-line', count: 720, description: '深宫谍影，步步惊心' },
  { id: 'comedy', slug: 'comedy', name: '轻松搞笑', icon: 'ri-emotion-laugh-line', count: 850, description: '笑看红尘，欢乐不断' },
  { id: 'horror', slug: 'horror', name: '悬疑惊悚', icon: 'ri-ghost-line', count: 460, description: '迷雾重重，步步揭秘' },
];

export const latestUpdates = [
  { id: 'l1', title: '剑雪归途', chapter: '第87话', time: '10分钟前', cover: 'https://readdy.ai/api/search-image?query=Snowy%20mountain%20swordsman%20manhwa%20thumbnail%2C%20white%20robed%20figure%20in%20snowstorm%2C%20minimalist%20ink%20wash%20style%2C%20cool%20blue%20and%20white%20tones&width=400&height=500&seq=latest-01&orientation=portrait' },
  { id: 'l2', title: '桃花庵下', chapter: '第102话', time: '25分钟前', cover: 'https://readdy.ai/api/search-image?query=Peach%20blossom%20romance%20manhwa%20thumbnail%2C%20pink%20dressed%20woman%20under%20blooming%20tree%2C%20soft%20watercolor%20style%2C%20warm%20pink%20tones&width=400&height=500&seq=latest-02&orientation=portrait' },
  { id: 'l3', title: '幻夜猫妖录', chapter: '第63话', time: '1小时前', cover: 'https://readdy.ai/api/search-image?query=Mysterious%20cat%20spirit%20manhwa%20thumbnail%2C%20ethereal%20feline%20in%20bamboo%20forest%2C%20silver%20moonlight%2C%20dreamy%20blue%20tones&width=400&height=500&seq=latest-03&orientation=portrait' },
  { id: 'l4', title: '玉楼春', chapter: '第58话', time: '2小时前', cover: 'https://readdy.ai/api/search-image?query=Jade%20pavilion%20palace%20lady%20manhwa%20thumbnail%2C%20green%20silk%20hanfu%2C%20moonlit%20scene%2C%20elegant%20jade%20tones&width=400&height=500&seq=latest-04&orientation=portrait' },
  { id: 'l5', title: '龙印传说', chapter: '第75话', time: '3小时前', cover: 'https://readdy.ai/api/search-image?query=Dragon%20warrior%20manhwa%20thumbnail%2C%20golden%20dragon%20in%20storm%2C%20dramatic%20dark%20tones%2C%20epic%20atmosphere&width=400&height=500&seq=latest-05&orientation=portrait' },
  { id: 'l6', title: '影刃', chapter: '第49话', time: '5小时前', cover: 'https://readdy.ai/api/search-image?query=Masked%20assassin%20manhwa%20thumbnail%2C%20rainy%20night%20scene%2C%20twin%20daggers%2C%20dark%20crimson%20tones&width=400&height=500&seq=latest-06&orientation=portrait' },
];

export const editorPick = {
  id: 'star-luo-jianghu',
  title: '星落江湖',
  author: '北辰',
  tagline: '主编力荐 · 本周必读',
  description: '星辰坠落于江湖，少年拾起一片星空。这是一部将东方玄幻与水墨美学完美融合的巅峰之作，每一帧画面都可入画，每一段故事都荡气回肠。北辰老师以独特的笔触，勾勒出一个充满想象力的浩瀚世界，让人沉醉其中，久久不能忘怀。',
  editorName: '墨染',
  editorTitle: '古风漫画网 · 内容主编',
  cover: 'https://readdy.ai/api/search-image?query=Stunning%20ancient%20Chinese%20fantasy%20manhwa%20cover%2C%20a%20young%20warrior%20reaching%20for%20falling%20stars%20in%20a%20vast%20cosmic%20landscape%2C%20ink%20wash%20and%20starry%20night%20fusion%20style%2C%20deep%20indigo%20and%20gold%20star%20tones%2C%20vertical%20format%2C%20breathtaking%20composition&width=600&height=800&seq=editor-pick-cover&orientation=portrait',
};

export const testimonials = [
  {
    id: 't1',
    name: '画中仙',
    avatar: 'https://readdy.ai/api/search-image?query=Minimalist%20round%20avatar%20portrait%2C%20young%20Asian%20woman%20in%20traditional%20style%2C%20soft%20watercolor%2C%20warm%20neutral%20background&width=120&height=120&seq=avatar-01&orientation=squarish',
    comment: '古风漫画网的阅读体验真的太棒了！下拉式观看特别流畅，画质也很清晰，每天都要来这里追更。',
    rating: 5,
    date: '2026-06-28',
  },
  {
    id: 't2',
    name: '江湖浪子',
    avatar: 'https://readdy.ai/api/search-image?query=Minimalist%20round%20avatar%20portrait%2C%20young%20Asian%20man%20with%20calm%20expression%2C%20ink%20wash%20style%2C%20neutral%20warm%20background&width=120&height=120&seq=avatar-02&orientation=squarish',
    comment: '终于找到了一个有古风韵味的韩漫平台！推荐的作品都很对胃口，分类也很清晰。',
    rating: 5,
    date: '2026-06-25',
  },
  {
    id: 't3',
    name: '书卷清风',
    avatar: 'https://readdy.ai/api/search-image?query=Minimalist%20round%20avatar%20portrait%2C%20elegant%20Asian%20woman%20reading%2C%20soft%20traditional%20painting%20style%2C%20warm%20light%20background&width=120&height=120&seq=avatar-03&orientation=squarish',
    comment: '网站设计很用心，既有古典韵味又不失现代感。免费阅读更是良心之作，强烈推荐！',
    rating: 5,
    date: '2026-06-20',
  },
];